import type { CountryCode, Locale } from './types';

export function getCountryCode(locale: Locale): CountryCode {
	return locale.split('-')[1] as CountryCode;
}
